module.exports = __webpack_public_path__ + "static/media/kung-fu-panda-statue.86b8883f.png";